import React, { useEffect, useState } from 'react';

import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Input } from '@wds/input';
import { InputMessage } from '@wds/input-message';
import { Textarea } from '@wds/textarea';

import PropTypes from 'prop-types';
import { STRINGS } from './constants';
import getComponentWithTheme from '../../../../themeProvider';

const TextCustomField = (props) => {
	const {
		id, label, value, onChange, required, readOnly, errors, setErrors, helperText, settings,
	} = props;
	const [state, setState] = useState(value);
	const [error, setError] = useState('');

	useEffect(() => {
		if (value && value.length > 0) {
			validateField(value);
		}
	}, []);

	useEffect(() => {
		if (errors?.[id]) {
			setError(errors[id]);
		} else {
			setError('');
		}
	}, [errors]);

	const handleChange = (e) => {
		validateField(e.target.value);
	};

	const validateField = (updatedValue) => {
		setState(updatedValue);
		const errorResult = settings.validator(updatedValue);
		if ((errorResult && updatedValue.length > 0) || (required && updatedValue.length === 0)) {
			setError(errorResult);
			setErrors({ ...errors, [id]: errorResult });
		} else {
			setError('');
			setErrors((prevErrors) => {
				const { [id]: _, ...rest } = prevErrors;
				return rest;
			});
			onChange(updatedValue);
		}
	};

	return (
		getComponentWithTheme(
			<>
				<InputGroup
					id={`${id}-input-group`}
					label={`${label} ${required ? '' : `(${STRINGS.optional})`}`}
					required={required}
					color={errors?.[id] ? 'error' : undefined}
					disabled={readOnly}
					stretched
				>
					{settings.addOn && (
						<InputGroupAddon>
							{settings.addOn}
						</InputGroupAddon>
					)}
					{
						settings.type === 'longtext' ? (
							<Textarea
								defaultValue={state}
								id={id}
								onChange={handleChange}
							/>
						) : (
							<Input
								value={state}
								type={settings.type}
								id={id}
								onChange={handleChange}
							/>
						)
					}
				</InputGroup>
				{helperText && <InputMessage id={`${id}-helper-text`}>{helperText}</InputMessage>}
				{errors?.[id] && <InputMessage color='error' id={`${id}-error-text`}>{error}</InputMessage>}
			</>,
		)
	);
};
TextCustomField.propTypes = {
	id: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	readOnly: PropTypes.bool,
	errors: PropTypes.object,
	setErrors: PropTypes.func,
	helperText: PropTypes.string,
	settings: PropTypes.object,
};
export default TextCustomField;
